import {
  createStyles,
  List,
  ListItem,
  ListItemText,
  Typography,
  makeStyles
} from '@material-ui/core';
import { SvgIconProps } from '@material-ui/core/SvgIcon';
import * as React from 'react';

export interface ICandidateSideInformation {
  icon: React.ComponentType<SvgIconProps>;
  data: any[];
  onClick?: () => void;
}

type CandidateInformationListProps = {
  items: ICandidateSideInformation[];
}

const useStyles = makeStyles(() => (createStyles({
  icon: { fontSize: "20px", color: "#617c94", maxWidth: "100%" }
})));

const CandidateInformationList: React.FunctionComponent<CandidateInformationListProps> = props => {
  const cssClasses = useStyles({});

  return (
    <div>
      <List disablePadding={true}>
        {props.items
          .filter(item => hasValidValues(item.data))
          .map((Info, i) => {
            return (
              <ListItem disableGutters={true} key={i} style={{ paddingTop: "0px" }}>
                {React.createElement(Info.icon, { className: cssClasses.icon })}
                <ListItemText style={{ cursor: "pointer" }} onClick={Info.onClick}>
                  <div>
                    {Info.data.map((element, j) => {
                      return (<Typography key={j}>{element}</Typography>);
                    })}
                  </div>
                </ListItemText>
              </ListItem>
            );
          }
          )}
      </List>
    </div>
  );
}

const hasValidValues = (items: ICandidateSideInformation[]): boolean => {
  return items.filter(Boolean).length > 0;
}

export default CandidateInformationList;
